import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { OperatorGroupDto } from '../../../../api/gen/model/operatorGroupDto';
import { OperatorGroupRole } from '../../../../api/gen/model/operatorGroupRole';
import { GroupMemberListComponent } from './group-member-list/group-member-list.component';

@Component({
  selector: 'app-group-item',
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    GroupMemberListComponent
  ],
  templateUrl: './group-item.component.html',
  styleUrl: './group-item.component.scss'
})
export class GroupItemComponent {
  @Input() group!: OperatorGroupDto;

  @Output() assignParkingSpace = new EventEmitter<OperatorGroupDto>();
  @Output() unassignParkingSpace = new EventEmitter<{ group: OperatorGroupDto; parkingSpaceId: string }>();
  @Output() memberRemoved = new EventEmitter<{ groupId: string; operatorId: string }>();
  @Output() addOperator = new EventEmitter<OperatorGroupDto>();

  getRoleAccentClass(role?: OperatorGroupRole | null): string {
    switch (role) {
      case OperatorGroupRole.SuperUser: return 'bg-purple-500';
      case OperatorGroupRole.Admin: return 'bg-rose-500';
      case OperatorGroupRole.Owner: return 'bg-amber-500';
      case OperatorGroupRole.Member: return 'bg-blue-500';
      case OperatorGroupRole.Viewer: return 'bg-gray-400';
      default: return 'bg-gray-300';
    }
  }

  getRoleIconBg(role?: OperatorGroupRole | null): string {
    switch (role) {
      case OperatorGroupRole.SuperUser: return 'bg-purple-500';
      case OperatorGroupRole.Admin: return 'bg-rose-500';
      case OperatorGroupRole.Owner: return 'bg-amber-500';
      case OperatorGroupRole.Member: return 'bg-blue-500';
      case OperatorGroupRole.Viewer: return 'bg-gray-400';
      default: return 'bg-gray-400';
    }
  }

  getRoleBadgeClass(role?: OperatorGroupRole | null): string {
    switch (role) {
      case OperatorGroupRole.SuperUser: return 'bg-purple-100 text-purple-700';
      case OperatorGroupRole.Admin: return 'bg-rose-100 text-rose-700';
      case OperatorGroupRole.Owner: return 'bg-amber-100 text-amber-700';
      case OperatorGroupRole.Member: return 'bg-blue-100 text-blue-700';
      case OperatorGroupRole.Viewer: return 'bg-gray-100 text-gray-600';
      default: return 'bg-gray-100 text-gray-600';
    }
  }

  onAssignParkingSpace(): void {
    this.assignParkingSpace.emit(this.group);
  }

  onUnassignParkingSpace(parkingSpaceId: string): void {
    this.unassignParkingSpace.emit({ group: this.group, parkingSpaceId });
  }

  onMemberRemoved(operatorId: string): void {
    if (this.group.id) {
      this.memberRemoved.emit({ groupId: this.group.id, operatorId });
    }
  }

  onAddOperator(): void {
    this.addOperator.emit(this.group);
  }
}
